var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata-box"},[_c('img',{attrs:{"src":require("@/assets/wu.png")}}),_c('span',{staticClass:"nodata-text"},[_vm._v("暂无数据")])])}]

export { render, staticRenderFns }